<template>
    <div>
        <div id="content-main ms-font-m">
            <div class="userContainer">
                
            </div>
            <b-container class="padding ms-font-m">
                <b-row>
                    <b-col cols="10">
                        <div class="userName">{{userName}}</div>
                    </b-col>
                    <b-col cols="2">
                        <a v-on:click="SighOut()" id="singout-button" class="" style="top:-10px; float:right;cursor:pointer;">Выход</a>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <div>

                            <br />

                            <div style="text-align:center">
                                <img src="../../Images/logo.png"/>
                            </div>

                            <br />

                            <!--Название-->
                            <div class="ms-Grid-row">
                                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                                    Название
                                </div>
                            </div>
                            <div class="ms-Grid-row">
                                <div class="ms-Grid-col ms-u-lg12">
                                    <input v-model="docData.name" id="docName" type="text" class="textBoxRound" />
                                </div>
                            </div>

                            <!--Тематика-->
                            <div class="ms-Grid-row">
                                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                                    Тематика
                                </div>
                            </div>
                            <div class="ms-Grid-row">
                                <div class="ms-Grid-col ms-u-lg12">
                                    <input id="theme" type="text" class="textBoxRound" />
                                </div>
                            </div>

                            <!--Ключевые слова-->
                            <div class="ms-Grid-row">
                                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                                    Ключевые слова
                                </div>
                            </div>
                            <div class="ms-Grid-row">
                                <div class="ms-Grid-col ms-u-lg12">
                                    <input id="keywords" type="text" class="textBoxRound" />
                                </div>
                            </div>

                            <!--Лицензия-->
                            <div class="ms-Grid-row">
                                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                                    Лицензия
                                </div>
                            </div>
                            <div class="ms-Grid-row">
                                <div class="ms-Grid-col ms-u-lg12">

                                    <select id="license" class="textBoxRound" style="width: 100%">
                                        <option title="Все права защищены, не может использоваться без согласия правообладателя">
                                            Copyright
                                        </option>

                                        <option title="Общественное достояние, используется без ограничений">
                                            PD
                                        </option>

                                        <option title="Открытая лицензия, возможно использование с указанием авторства">
                                            CC BY
                                        </option>

                                        <option title="Открытая лицензия, возможно использовать с указанием авторства и выполнением условий использования для создания производных произведений»">
                                            CC BY-SA
                                        </option>

                                        <option title="Открытая лицензия, возможно использовать без права создания производных произведений, с обязательным указанием авторства">
                                            CC BY-ND
                                        </option>

                                        <option title="Открытая лицензия, возможно использовать только для некоммерческого использования с обязательным указанием авторства">
                                            CC BY-NC
                                        </option>

                                        <option title="Открытая лицензия, возможно использовать с указанием авторства и выполнением условий использования для создания производных произведений только для некоммерческого использования">
                                            CC BY-NC-SA
                                        </option>

                                        <option title="Открытая лицензия, возможно использовать с указанием авторства без права создания производных произведений только для некоммерческого использования">
                                            CC BY-NC-ND
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <br />

                            <div class="ms-font-m">
                                <div class="ms-Grid">
                                    <div class="ms-Grid-row">
                                        <div class="ms-Grid-col ms-u-lg12">
                                            <div class="ms-Grid-row">
                                                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                                                    Участники создания объекта
                                                </div>
                                            </div>

                                            <br />

                                            <div class="ms-Grid-row">
                                                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                                                    Авторы:
                                                </div>

                                            </div>
                                            <div class="ms-Grid-row">
                                                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                                                    <label for="isEqualRateAuthorsCheck" style="word-wrap:break-word">
                                                        Равные доли
                                                        <input style="vertical-align: middle;" id="isEqualRateAuthorsCheck" type="checkbox"
                                                               v-model="isEqualRateAuthors"
                                                               v-on:change="IsEqualRateAuthorsChange()" />
                                                    </label>
                                                    <label for="isEqualRateAuthorsCheck" style="word-wrap:break-word;margin-left: 20px;">
                                                        Юридическое лицо
                                                        <input style="vertical-align: middle;" id="newAuthorisLegalEntity" type="checkbox"
                                                               v-model="newAuthor.isLegalEntity" />
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="ms-Grid-row">
                                                <div class="ms-Grid-col ms-u-lg12">
                                                    <b-row v-if="!newAuthor.isLegalEntity">
                                                        <b-col>
                                                            <input v-model="newAuthor.surname" id="authorSurname" type="text" class="textBox" placeholder="Фамилия" @input="authorsSuggest($event)" />
                                                        </b-col>
                                                        <b-col>
                                                            <input v-model="newAuthor.name" id="authorName" type="text" class="textBox" placeholder="Имя" @input="authorsSuggest($event)" />
                                                        </b-col>
                                                        <b-col>
                                                            <input v-model="newAuthor.lastname" id="authorLastName" type="text" class="textBox" placeholder="Отчество" @input="authorsSuggest($event)" />
                                                        </b-col>
                                                        <b-col cols="3" v-if="!isEqualRateAuthors">
                                                            <input v-model="newAuthor.weight" id="authorWeight" type="text" class="textBox" placeholder="Доля,%" />
                                                        </b-col>
                                                        <b-col cols="1">
                                                            <button v-on:click="addAuthor()" id="button-author-add" class="buttonSmall" style="background-color:#44adf3;">+</button>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row v-if="newAuthor.isLegalEntity">
                                                        <b-col>
                                                            <input v-model="newAuthor.name" id="authorName" type="text" class="textBox" placeholder="Название" />
                                                        </b-col>
                                                        <b-col>
                                                            <input v-model="newAuthor.inn" id="authorInn" type="text" class="textBox" placeholder="ИНН" />
                                                        </b-col>
                                                        <b-col v-if="!isEqualRateAuthors">
                                                            <input v-model="newAuthor.weight" id="authorWeight" type="text" class="textBox" placeholder="Доля,%" />
                                                        </b-col>
                                                        <b-col cols="1">
                                                            <button v-on:click="addAuthor()" id="button-author-add" class="buttonSmall" style="background-color:#44adf3;">+</button>
                                                        </b-col>
                                                    </b-row>
                                                    <div class="dropdown" v-if="displayAuthorsSuggest">
                                                        <div id="authorsDropdown" class="dropdown-content">
                                                            <span v-for="item in suggestItems" v-bind:key="item" @click="selectSuggestedAuthor(item)">
                                                                {{ item.Surname }} {{item.Name}} {{item.Lastname}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="ms-Grid-row">
                                                <div class="ms-Grid-col ms-u-lg12">
                                                    <span style="color:red" v-if="!isAuthorsRatesValid">Сумма долей не должна быть больше 100% или 1</span>
                                                    <b-row v-for="item in authors" v-bind:key="item">
                                                        <b-col v-if="!item.isLegalEntity">
                                                            <div class="textAlignCentre">{{item.surname}}</div>
                                                        </b-col>
                                                        <b-col v-if="!item.isLegalEntity">
                                                            <div class="textAlignCentre">{{item.name}}</div>
                                                        </b-col>
                                                        <b-col v-if="!item.isLegalEntity">
                                                            <div class="textAlignCentre">{{item.lastname}}</div>
                                                        </b-col>
                                                        <b-col v-if="item.isLegalEntity" cols="4">
                                                            <div class="textAlignCentre">{{item.name}}</div>
                                                        </b-col>
                                                        <b-col v-if="item.isLegalEntity" cols="4">
                                                            <div class="textAlignCentre">{{item.inn}}</div>
                                                        </b-col>
                                                        <b-col v-if="!isEqualRateAuthors" cols="3">
                                                            <input v-model="item.weight" type="text" class="textBox" placeholder="Доля,%" v-on:change="validateAuthorsRate($event)" />
                                                        </b-col>
                                                        <b-col v-if="isEqualRateAuthors" cols="3">
                                                            <div class="textAlignCentre cellWeight">{{item.weight}}</div>
                                                        </b-col>
                                                        <b-col cols="1" style="margin-top: 5px;">
                                                            <button @click="removeAuthor(item.index)" class="buttonSmall" style="background-color:#fb5454;">-</button>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                            </div>

                                            <div class="ms-Grid-row" style="margin-top:15px;">
                                                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                                                    Правообладатели:
                                                    <button v-on:click="CopyAuthorsToIpRights()" id="button-ipright-add" class="buttonSmall" style="background-color:#44adf3;">&#8595;</button>
                                                </div>
                                            </div>
                                            <div class="ms-Grid-row">
                                                <div class="ms-Grid-col ms-u-lg12 ms-fontColor-neutralTertiary">
                                                    <label for="isEqualRateIPRightsCheck" style="word-wrap:break-word">
                                                        Равные доли
                                                        <input style="vertical-align: middle;" id="isEqualRateIPRightsCheck" type="checkbox"
                                                               v-model="isEqualRateIPRights"
                                                               v-on:change="IsEqualRateIPRightsChange()" />
                                                    </label>
                                                    <label for="newIPLegalEntity" style="word-wrap:break-word;margin-left: 20px;">
                                                        Юридическое лицо
                                                        <input style="vertical-align: middle;" id="newIPLegalEntity" type="checkbox"
                                                               v-model="newIpright.isLegalEntity" />
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="ms-Grid-row">
                                                <div class="ms-Grid-col ms-u-lg12">
                                                    <b-row v-if="!newIpright.isLegalEntity">
                                                        <b-col>
                                                            <input v-model="newIpright.surname" id="iprightSurname" type="text" class="textBox" placeholder="Фамилия" @input="ipRightsSuggest($event)" />
                                                        </b-col>
                                                        <b-col>
                                                            <input v-model="newIpright.name" id="iprightName" type="text" class="textBox" placeholder="Имя" @input="ipRightsSuggest($event)" />
                                                        </b-col>
                                                        <b-col>
                                                            <input v-model="newIpright.lastname" id="iprightLastName" type="text" class="textBox" placeholder="Отчество" @input="ipRightsSuggest($event)" />
                                                        </b-col>
                                                        <b-col cols="3" v-if="!isEqualRateIPRights">
                                                            <input v-model="newIpright.weight" id="iprightWeight" type="text" class="textBox" placeholder="Доля,%" />
                                                        </b-col>
                                                        <b-col cols="1">
                                                            <button v-on:click="addIpright()" id="button-ipright-add" class="buttonSmall" style="background-color:#44adf3;">+</button>
                                                        </b-col>
                                                    </b-row>
                                                    <b-row v-if="newIpright.isLegalEntity">
                                                        <b-col>
                                                            <input v-model="newIpright.name" id="IprightName" type="text" class="textBox" placeholder="Название" />
                                                        </b-col>
                                                        <b-col>
                                                            <input v-model="newIpright.inn" id="IprightInn" type="text" class="textBox" placeholder="ИНН" />
                                                        </b-col>
                                                        <b-col v-if="!isEqualRateIPRights">
                                                            <input v-model="newIpright.weight" id="IprightWeight" type="text" class="textBox" placeholder="Доля,%" />
                                                        </b-col>
                                                        <b-col cols="1">
                                                            <button v-on:click="addIpright()" id="button-ipright-add" class="buttonSmall" style="background-color:#44adf3;">+</button>
                                                        </b-col>
                                                    </b-row>
                                                    <div class="dropdown" v-if="displayIPRightsSuggest">
                                                        <div class="dropdown-content">
                                                            <span v-for="item in suggestItemsIPRights" v-bind:key="item" @click="selectSuggestedIPRight(item)">
                                                                {{ item.Surname }} {{item.Name}} {{item.Lastname}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                            <div class="ms-Grid-row">
                                                <div class="ms-Grid-col ms-u-lg12">
                                                    <span style="color:red" v-if="!isIPRightsRatesValid">Сумма долей не должна быть больше 100% или 1</span>
                                                    <b-row v-for="item in iprights" v-bind:key="item">
                                                        <b-col v-if="!item.isLegalEntity">
                                                            <div class="textAlignCentre">{{item.surname}}</div>
                                                        </b-col>
                                                        <b-col v-if="!item.isLegalEntity">
                                                            <div class="textAlignCentre">{{item.name}}</div>
                                                        </b-col>
                                                        <b-col v-if="!item.isLegalEntity">
                                                            <div class="textAlignCentre">{{item.lastname}}</div>
                                                        </b-col>
                                                        <b-col v-if="item.isLegalEntity" cols="4">
                                                            <div class="textAlignCentre">{{item.name}}</div>
                                                        </b-col>
                                                        <b-col v-if="item.isLegalEntity" cols="4">
                                                            <div class="textAlignCentre">{{item.inn}}</div>
                                                        </b-col>
                                                        <b-col v-if="!isEqualRateIPRights" cols="3">
                                                            <input v-model="item.weight" type="text" class="textBox" placeholder="Доля,%" v-on:change="validateIPrightsRate($event)" />
                                                        </b-col>
                                                        <b-col v-if="isEqualRateIPRights" cols="3">
                                                            <div class="textAlignCentre cellWeight">{{item.weight}}</div>
                                                        </b-col>
                                                        <b-col cols="1" style="margin-top: 5px;">
                                                            <button @click="removeIpright(item.index)" class="buttonSmall" style="background-color:#fb5454;">-</button>
                                                        </b-col>
                                                    </b-row>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div style="text-align: center; width: 100%">
                                <button v-on:click="getDocument()"
                                        v-bind:disabled="publishDisabled"
                                        class="button" id="highlight-button" style="margin:0 auto">Депонировать</button>
                                <!--<button v-on:click="testDoc()" class="button" id="highlight-button" style="margin:0 auto">Тест</button>-->
                                <!--<button class="button" id="signid-button" style="margin:0 auto">Войти</button>-->
                                <div id="container"></div>
                                <label id="processing">Идет публикация...</label>

                                <div id="errorDiv" style="margin-top: 10px">
                                    <button class="collapsible">+ Ошибка при публикации</button>
                                    <div class="content">
                                        <p id="errorTest"></p>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
        <notifications group="foo" />
    </div>
</template>

<script>
    import $ from 'jquery'
    import AuthSvc from '../classes/AuthSvc';
    import { sha256 } from 'js-sha256';
    //import Office from 'Office'
    const Office = window.Office;
    import VueSuggestion from 'vue-suggestion'
    import router from '../main'
    import NotificationsSvc from '../../src/classes/NotificationsSvcT'

    export default {
        data () {
            return {
                publishDisabled:false,
                isAuthorsRatesValid: true,
                isIPRightsRatesValid:true,
                isEqualRateAuthors: false,
                isEqualRateIPRights:false,
                suggestItems: [],
                suggestItemsIPRights: [],
                displayAuthorsSuggest: false,
                displayIPRightsSuggest: false,

                userName: 'Тест',
                authors:[],
                iprights: [],
                data: {},
                userData: {
                },
                notificationHeader: '',
                notificationBody: '',
                sessionId: null,
                docData: {
                    name
                },
                newAuthor: {
                    name:'',
                    surname:'',
                    lastname:'',
                    weight: '',
                    isLegalEntity:false
                },
                newIpright: {
                    name:'',
                    surname:'',
                    lastname:'',
                    weight: '',
                    isLegalEntity:false
                }
            }
        },
        mounted: function () {
            this.refreshAuthors();
            this.refreshIprights();
            this.docData.name = "";

            $('#processing').hide();
            $('#errorDiv').hide();
        },
        created: function () {
            //debugger // eslint-disable-line
            //debugger;
            var that = this;

            var userDataStr = localStorage.getItem("userData");
            if (userDataStr) {
                this.userData = JSON.parse(userDataStr);

                if (this.userData.names && this.userData.names.length > 0) {
                    this.userName = this.userData.names[0].last_name + ' ' + this.userData.names[0].first_name + ' ' + this.userData.names[0].middle_name;
                    var data = {
                        index: 1,
                        name: this.userData.names[0].first_name,
                        surname: this.userData.names[0].last_name,
                        lastname: this.userData.names[0].middle_name,
                        weight: "100",
                        isLegalEntity:false
                    };

                    this.authors.push(JSON.parse(JSON.stringify(data)));
                    this.iprights.push(JSON.parse(JSON.stringify(data)));
                }
                else if (this.userData.identifiers && this.userData.identifiers.length > 0) {
                    this.userName = this.userData.identifiers[0].identifier;
                }
                else {
                    this.userName = this.userData.id;
                }
            }

            this.docData.name = "";

            window.onclick = function(event) {
                that.displayAuthorsSuggest = false;
                that.displayIPRightsSuggest = false;
            }
        },
        methods: {
            testDoc() {
                this.goToRegistredObj("0e636b15-dbfe-4eb9-7f5a-ac6a1d5184c8", "a22a907a-eece-4126-6d22-36366aa68dcd");
            },
            selectSuggestedAuthor(item) {
                this.newAuthor.surname = item.Surname;
                this.newAuthor.name = item.Name;
                this.newAuthor.lastname = item.Lastname;

                this.displayAuthorsSuggest = false;
            },
            IsEqualRateAuthorsChange() {
                if (this.authors && this.authors.length > 0 && this.isEqualRateAuthors) {
                    var newWeight =  (100 / this.authors.length).toFixed(2);
                    for (var i = 0; i < this.authors.length; i++) {
                        this.authors[i].weight = newWeight + "";
                    }
                    this.refreshAuthors();
                }
            },
            IsEqualRateIPRightsChange() {
                if (this.iprights && this.iprights.length > 0 && this.isEqualRateIPRights) {
                    var newWeight = (100 / this.iprights.length).toFixed(2);
                    for (var i = 0; i < this.iprights.length; i++) {
                        this.iprights[i].weight = newWeight + "";
                    }
                    this.refreshIprights();
                }
            },
            CopyAuthorsToIpRights() {
                if (this.authors && this.authors.length > 0) {
                    this.iprights = [];
                    var maxId = 0;

                    for (var i = 0; i < this.authors.length; i++) {
                        var newIpright = this.authors[i];
                        

                        this.iprights.push({ index: maxId + 1, name: newIpright.name, surname: newIpright.surname, lastname: newIpright.lastname, weight: newIpright.weight });


                        if (this.isEqualRateIPRights) {
                            this.IsEqualRateIPRightsChange();
                        }
                        else {
                            this.refreshIprights();
                        }
                    }
                }
            },

            authorsSuggest(e) {
                var text = this.newAuthor.surname;// + " " + this.newAuthor.name + " " + this.newAuthor.lastname;
                text = e.target.value;

                if (text.length < 3) {
                    return;
                }

                var that = this;
                $.get(process.env.VUE_APP_ROOT_API + 'api/suggestAuthors?userId=' + that.userData.id + '&text=' + encodeURI(text), function (result) {
                    that.suggestItems = result;

                    that.displayAuthorsSuggest = true;
                });
            },
            selectSuggestedIPRight(item) {
                this.newIpright.surname = item.Surname;
                this.newIpright.name = item.Name;
                this.newIpright.lastname = item.Lastname;

                this.displayIPRightsSuggest = false;
            },
            ipRightsSuggest(e) {
                var text = this.newIpright.surname;// + " " + this.newAuthor.name + " " + this.newAuthor.lastname;
                text = e.target.value;

                if (text.length < 3) {
                    return;
                }

                var that = this;
                $.get(process.env.VUE_APP_ROOT_API + 'api/suggestIPRight?userId=' + that.userData.id + '&text=' + encodeURI(text), function (result) {
                    that.suggestItemsIPRights = result;

                    that.displayIPRightsSuggest = true;
                });
            },

            refreshAuthors() {
                // cache <tbody> element:
                //var tbody = $('#authorsBody');
                //tbody.empty();
                //var that = this;

                //for (var i = 0; i < this.authors.length; i++) {
                //    // create an <tr> element, append it to the <tbody> and cache it as a variable:
                //    var tr = $('<tr/>').appendTo(tbody);

                //    tr.append('<td style="color:#3e3e3e; width:25%">' + this.authors[i].surname + '</td>');
                //    tr.append('<td style="color:#3e3e3e; width:25%">' + this.authors[i].name + '</td>');
                //    tr.append('<td style="color:#3e3e3e; width:25%">' + this.authors[i].lastname + '</td>');
                //    tr.append('<td class="cellWeight">' + this.authors[i].weight + '</td>');
                //    tr.append('<td><button id="author_' + this.authors[i].index + '" class="buttonSmall" style="background-color:#fb5454;">-</button></td>');

                //    document.getElementById("author_" + this.authors[i].index).addEventListener("click", function (e) {
                //        var id = $(e.target).attr('id');
                //        that.removeAuthor(parseInt(id.split('_')[1]));
                //    });
                //}
            },

            refreshIprights() {
                // cache <tbody> element:
                //var that = this;
                //var tbody = $('#iprightsBody');
                //tbody.empty();

                //for (var i = 0; i < this.iprights.length; i++) {
                //    // create an <tr> element, append it to the <tbody> and cache it as a variable:
                //    var tr = $('<tr/>').appendTo(tbody);

                //    tr.append('<td style="color:#3e3e3e; width:25%">' + this.iprights[i].surname + '</td>');
                //    tr.append('<td style="color:#3e3e3e; width:25%">' + this.iprights[i].name + '</td>');
                //    tr.append('<td style="color:#3e3e3e; width:25%">' + this.iprights[i].lastname + '</td>');

                //    tr.append('<td class="cellWeight">' + this.iprights[i].weight + '</td>');
                //    tr.append('<td><button id="ipright_' + this.iprights[i].index + '" class="buttonSmall" style="background-color:#fb5454;">-</button></td>');

                //    document.getElementById("ipright_" + this.iprights[i].index).addEventListener("click", function (e) {
                //        var id = $(e.target).attr('id');
                //        that.removeIpright(parseInt(id.split('_')[1]));
                //    });
                //}
            },

            SighOut() {
                AuthSvc.SighOut();
            },
            fractionToDecimal(fraction) {
                var split = fraction.split('/');
                var top = parseFloat(split[0]);
                var bot = parseFloat(split[1]);
                return (top / bot) * 100;
            },
            validateAuthorsRate(e) {
                if (this.isEqualRateAuthors) {
                    this.isAuthorsRatesValid = true;
                    return;
                }

                var sum = 0;

                var isFraction = false;
                for (var i = 0; i < this.authors.length; ++i) {
                    if (typeof this.authors[i].weight === 'string'&& this.authors[i].weight.indexOf('/') > -1) {
                        isFraction = true;
                    }
                }

                for (i = 0; i < this.authors.length; ++i) {
                    if (isFraction == false) {
                        sum += +this.authors[i].weight;
                    }
                    else {
                        sum += this.fractionToDecimal(this.authors[i].weight)
                    }
                }

                if (sum > 100) {
                    this.isAuthorsRatesValid = false;
                }
                else {
                    this.isAuthorsRatesValid = true;
                }
            },
            validateIPrightsRate(e) {
                if (this.isEqualRateIPRights) {
                    this.isIPRightsRatesValid = true;
                    return;
                }

                var sum = 0;

                var isFraction = false;
                for (var i = 0; i < this.iprights.length; ++i) {
                    if (typeof this.iprights[i].weight === 'string'&& this.iprights[i].weight.indexOf('/') > -1) {
                        isFraction = true;
                    }
                }

                for (i = 0; i < this.iprights.length; ++i) {
                    if (isFraction == false) {
                        sum += +this.iprights[i].weight;
                    }
                    else {
                        sum += this.fractionToDecimal(this.iprights[i].weight)
                    }
                }

                if (sum > 100) {
                    this.isIPRightsRatesValid = false;
                }
                else {
                    this.isIPRightsRatesValid = true;
                }
                
            },
            addAuthor() {
                if (this.newAuthor.name && this.isEqualRateAuthors) {
                    var maxId = 0;

                    for (i = 0; i < this.authors.length; ++i) {
                        if (this.authors[i].index > maxId) {
                            maxId = this.authors[i].index;
                        }
                    }
                    this.authors.push({ index: maxId + 1, name: this.newAuthor.name, surname: this.newAuthor.surname, lastname: this.newAuthor.lastname, weight: this.newAuthor.weight, isLegalEntity: this.newAuthor.isLegalEntity,
                            inn: this.newAuthor.inn });
                    this.IsEqualRateAuthorsChange();
                    this.newAuthor = {};
                    return;
                }
                
                var sum = 0;
                var weightReal = 0;

                var isFraction = false;
                for (var i = 0; i < this.authors.length; ++i) {
                    if (typeof this.authors[i].weight === 'string'&& this.authors[i].weight.indexOf('/') > -1) {
                        isFraction = true;
                    }
                }

                for (i = 0; i < this.authors.length; ++i) {
                    if (isFraction == false) {
                        sum += +this.authors[i].weight;
                    }
                    else {
                        sum += this.fractionToDecimal(this.authors[i].weight)
                    }
                }

                if (typeof this.newAuthor.weight === 'string' && this.newAuthor.weight.indexOf('/') > -1) {
                    isFraction = true;
                    weightReal = this.fractionToDecimal(this.newAuthor.weight);
                }
                else {
                    weightReal = parseFloat(this.newAuthor.weight);
                }

                if (sum + weightReal > 100)
                    return;
        
                if (this.newAuthor.name && weightReal && weightReal >= 0 && weightReal <= 100) {
                    var maxId = 0;

                    for (i = 0; i < this.authors.length; ++i) {
                        if (this.authors[i].index > maxId) {
                            maxId = this.authors[i].index;
                        }
                    }

                    this.authors.push(
                        {
                            index: maxId + 1,
                            name: this.newAuthor.name,
                            surname: this.newAuthor.surname,
                            lastname: this.newAuthor.lastname,
                            weight: this.newAuthor.weight,
                            isLegalEntity: this.newAuthor.isLegalEntity,
                            inn: this.newAuthor.inn
                        });
                    this.refreshAuthors();
                    this.newAuthor = { isLegalEntity: false };
                }
            },

            addIpright() {
                if (this.newIpright.name && this.isEqualRateIPRights) {
                    var maxId = 0;

                    for (i = 0; i < this.iprights.length; ++i) {
                        if (this.iprights[i].index > maxId) {
                            maxId = this.iprights[i].index;
                        }
                    }

                    this.iprights.push({ index: maxId + 1, name: this.newIpright.name, surname: this.newIpright.surname, lastname: this.newIpright.lastname, weight: this.newIpright.weight, isLegalEntity: this.newIpright.isLegalEntity,inn: this.newIpright.inn });
                    this.IsEqualRateIPRightsChange();
                    this.newIpright = {};
                    return;
                }

                var sum = 0;
                var weightReal = 0;

                var isFraction = false;
                for (var i = 0; i < this.iprights.length; ++i) {
                    if (typeof this.iprights[i].weight === 'string'&& this.iprights[i].weight.indexOf('/') > -1) {
                        isFraction = true;
                    }
                }

                for (i = 0; i < this.iprights.length; ++i) {
                    if (isFraction == false) {
                        sum += +this.iprights[i].weight;
                    }
                    else {
                        sum += this.fractionToDecimal(this.iprights[i].weight)
                    }
                }

                if (typeof this.newIpright.weight === 'string' && this.newIpright.weight.indexOf('/') > -1) {
                    isFraction = true;
                    weightReal = this.fractionToDecimal(this.newIpright.weight);
                }
                else {
                    weightReal = parseFloat(this.newIpright.weight);
                }

                if (sum + weightReal > 100)
                    return;
        
                if (this.newIpright.name && weightReal && weightReal >= 0 && weightReal <= 100) {
                    var maxId = 0;

                    for (i = 0; i < this.iprights.length; ++i) {
                        if (this.iprights[i].index > maxId) {
                            maxId = this.iprights[i].index;
                        }
                    }

                    this.iprights.push({ index: maxId + 1, name: this.newIpright.name, surname: this.newIpright.surname, lastname: this.newIpright.lastname, weight: this.newIpright.weight, isLegalEntity: this.newIpright.isLegalEntity,inn: this.newIpright.inn });
                    this.refreshIprights();
                    this.newIpright = { isLegalEntity: false };
                }
            },

            removeAuthor(index) {
                for (var i = 0; i < this.authors.length; i++) {
                    if (this.authors[i].index === index) {
                        this.authors.splice(i, 1);
                    }
                }

                this.refreshAuthors();
            },

            removeIpright(index) {
                for (var i = 0; i < this.iprights.length; i++) {
                    if (this.iprights[i].index === index) {
                        this.iprights.splice(i, 1);
                    }
                }

                this.refreshIprights();
            },

            getDocument() {
                if (this.authors.length == 0) {
                    NotificationsSvc.Notify("", "Добавьте хотя бы одного автора");
                    return;
                }

                this.publishDisabled = true;
                NotificationsSvc.Notify("", "Идёт публикация");
                if (location.search.indexOf("Word") > 0) {
                    this.getDocumentAsText();
                }
                else {
                    this.getDocumentAsCompressed();
                }
            },

            createDocumentData(dataToHash) {
                var docdata = [];

                for (var i = 0; i < dataToHash.length; i++) {
                    docdata = docdata.concat(dataToHash[i]);
                }

                var hash = sha256(docdata.join(''));
                this.data = {
                    name: this.docData.name,
                    keywords: $('#keywords').val(),
                    license: $('#license').val(),
                    theme: $('#theme').val(),
                    dataHash: hash,
                    authors: this.authors,
                    iprights: this.iprights,
                    extension: '.docx',
                    isEqualRateAuthors: this.isEqualRateAuthors,
                    isEqualRateIPRights:this.isEqualRateIPRights
                }
            },

            getDocumentAsText() {
                var that = this;
                $('#highlight-button').hide();
                $('#errorDiv').hide();
                $('#processing').show();

                Office.context.document.getFileAsync(Office.FileType.Text, { sliceSize: 65536 /*64 KB*/ },
                    function (result) {
                        if (result.status === "succeeded") {
                            // If the getFileAsync call succeeded, then
                            // result.value will return a valid File Object.
                            var myFile = result.value;
                            var sliceCount = myFile.sliceCount;
                            var slicesReceived = 0, gotAllSlices = true, docdataSlices = [];
                            //app.showNotification("File size:" + myFile.size + " #Slices: " + sliceCount);

                            // Get the file slices.
                            that.getSliceAsync(myFile, 0, sliceCount, gotAllSlices, docdataSlices, slicesReceived);
                        }
                        else {
                            NotificationsSvc.Notify("Error:", result.error.message);
                            $('#highlight-button').show();
                            $('#processing').hide();
                        }
                    });
            },

            getSliceAsync(file, nextSlice, sliceCount, gotAllSlices, docdataSlices, slicesReceived) {
                var that = this;
                file.getSliceAsync(nextSlice, function (sliceResult) {
                    if (sliceResult.status == "succeeded") {
                        if (!gotAllSlices) { // Failed to get all slices, no need to continue.
                            return;
                        }

                        // Got one slice, store it in a temporary array.
                        // (Or you can do something else, such as
                        // send it to a third-party server.)
                        docdataSlices[sliceResult.value.index] = sliceResult.value.data;
                        if (++slicesReceived == sliceCount) {
                            // All slices have been received.
                            file.closeAsync();
                            that.onGotAllSlices(docdataSlices);
                        }
                        else {
                            that.getSliceAsync(file, ++nextSlice, sliceCount, gotAllSlices, docdataSlices, slicesReceived);
                        }
                    }
                    else {
                        gotAllSlices = false;
                        file.closeAsync();
                        $('#highlight-button').show();
                        $('#processing').hide();
                        NotificationsSvc.Notify("getSliceAsync Error:", sliceResult.error.message);
                    }
                });
            },

            onGotAllSlices(docdataSlices) {
                this.createDocumentData(docdataSlices);
                this.getDocumentAsCompressed();
            },
            // GET COMPRESSED

            getDocumentAsCompressed() {
                var that = this;
                Office.context.document.getFileAsync(Office.FileType.Compressed, { sliceSize: 65536 /*64 KB*/ },
                    function (result) {
                        if (result.status == "succeeded") {
                            // If the getFileAsync call succeeded, then
                            // result.value will return a valid File Object.
                            var myFile = result.value;
                            var sliceCount = myFile.sliceCount;
                            var slicesReceived = 0, gotAllSlices = true, docdataSlices = [];
                            //app.showNotification("File size:" + myFile.size + " #Slices: " + sliceCount);

                            // Get the file slices.
                            that.getSliceCompressedAsync(myFile, 0, sliceCount, gotAllSlices, docdataSlices, slicesReceived);
                        }
                        else {
                            $('#highlight-button').show();
                            $('#processing').hide();
                            NotificationsSvc.Notify("Error getDocumentAsCompressed:", result.error.message);
                        }
                    });
            },

            getSliceCompressedAsync(file, nextSlice, sliceCount, gotAllSlices, docdataSlices, slicesReceived) {
                var that = this;
                file.getSliceAsync(nextSlice, function (sliceResult) {
                    if (sliceResult.status == "succeeded") {
                        if (!gotAllSlices) { // Failed to get all slices, no need to continue.
                            return;
                        }

                        // Got one slice, store it in a temporary array.
                        // (Or you can do something else, such as
                        // send it to a third-party server.)
                        docdataSlices[sliceResult.value.index] = sliceResult.value.data;
                        if (++slicesReceived == sliceCount) {
                            // All slices have been received.
                            file.closeAsync();
                            that.onGotAllCompressedSlices(docdataSlices);
                        }
                        else {
                            that.getSliceCompressedAsync(file, ++nextSlice, sliceCount, gotAllSlices, docdataSlices, slicesReceived);
                        }
                    }
                    else {
                        gotAllSlices = false;
                        file.closeAsync();
                        $('#highlight-button').show();
                        $('#processing').hide();
                        NotificationsSvc.Notify("getSliceAsync Error:", sliceResult.error.message);
                    }
                });
            },

            onGotAllCompressedSlices(docdataSlices) {
                if (location.search.indexOf("Word") == -1) {
                    this.createDocumentData(docdataSlices);
                    this.data.extension = '.pptx'
                }

                var docdata = [];
                var that = this;
                for (var i = 0; i < docdataSlices.length; i++) {
                    docdata = docdata.concat(docdataSlices[i]);
                }

                this.data.compressed = this._arrayBufferToBase64(docdata);
                var jsonData = JSON.stringify(this.data);

                $.post(process.env.VUE_APP_ROOT_API + 'api/objects?userId=' + that.userData.id, jsonData, function (result) {
                    that.goToRegistredObj(result.uid, result.clue);
                    window.open(result.payUrl)
                }).fail(function (response) {
                    //console.log(response);
                    $('#processing').hide();
                    $('#highlight-button').show();
                    that.publishDisabled = false;
                    //$('#errorTest').text(response.status.toString() + ' - ' + response.statusText);
                    //$('#errorDiv').show();

                    NotificationsSvc.Notify("Ошибка при загрузке объекта:", response.status.toString() + ' - ' + response.responseText);
                });
            },

            goToRegistredObj(uid, clue) {
                this.$router.push({ path: '/RegisteredObject/' + uid + '/' + clue });
            },

            _arrayBufferToBase64(buffer) {
                var binary = '';
                var bytes = new Uint8Array(buffer);
                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode(bytes[i]);
                }
                return window.btoa(binary);
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import '../../Content/Home.css';
    @import '../../Content/fabric.css';
    @import '../../Content/fabric.components.css';
    @import '../../Content/fabric.rtl.css';
</style>
